var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmexLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 55,
    viewBox: "0 0 74 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_13368_115422)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 6,
    width: 52,
    height: 33.5,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.875,
    y: 5.875,
    width: 52.25,
    height: 33.75,
    rx: 6.125,
    stroke: "#D6DCE5",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.0197 12.3153H58.7156L56.4659 18.7715L54.1182 12.3153H49.7164V22.368L45.2166 12.3153H41.5975L37.0977 22.5863H40.2278L41.1082 20.5322H45.8036L46.684 22.5863H52.5531V15.4454L55.1942 22.5863H57.6396L60.2807 15.4454V22.5863H63.0197V24.1513H59.4003L56.4659 27.3794L53.4335 24.1513H41.0105V34.4223H53.3358L56.3679 31.0965L59.4003 34.4223H63.0197V35.6937H58.7156L56.3679 33.1506L54.0202 35.6937H39.4454V23.9557H34.75L40.6191 10.75H46.2926L48.3467 15.2498V10.75H55.3898L56.5636 14.1737L57.7376 10.75H63.0197V12.3153ZM63.0197 26.4011L60.3786 29.2378L63.0197 32.0746V34.4223L58.2266 29.2378L63.0197 24.1513V26.4011ZM49.7164 34.4223V31.9769H43.8472V30.4118H49.6184V28.0641H43.8472V26.499H49.7164V24.1513L54.6072 29.2378L49.7164 34.4223ZM41.9885 18.2822L43.3582 14.9564L44.7276 18.2822H41.9885Z",
    fill: "#006FCF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_13368_115422",
    x: 0.75,
    y: 0.75,
    width: 72.5,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13368_115422"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_13368_115422",
    result: "effect2_dropShadow_13368_115422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_13368_115422",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmexLogo);
export default __webpack_public_path__ + "static/media/amex-logo.3abac9cbadf2e4ec30747093e7bffe8b.svg";
export { ForwardRef as ReactComponent };